(function() {
  'use strict';

  angular
    .module('admin.print_lookup.service', [])
    .factory('PrintLookupService', PrintLookupService);

  /** @ngInject */
  function PrintLookupService($http, $q, API) {

    function list(start, limit, collectibleId){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/collectibles/' + collectibleId + '/prints?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    return{
      list: list,
    };

  }

})();
